export enum UserStatusEnum {
    Active = 1,
    Suspended = 2,
    Deceased = 3,
    Removed = 4
}
